import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminHeader from '../components/AdminHeader';

const Coupons = () => {
    const [coupons, setCoupons] = useState([]);
    const [loading, setLoading] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9012/api/onlineorder';

    const [formData, setFormData] = useState({
        CouponCode: '',
        Description: '',
        DiscType: 'PERCENTAGE',
        DiscValue: '',
        MinOrderAmnt: '',
        MaxDiscount: '',
        SDate: '',
        EDate: '',
        UsageLimit: '',
        PerUserLimit: '',
        IsActive: true,
        ApplicableTo: 'CART'
    });

    useEffect(() => {
        fetchCoupons();
    }, []);

    const fetchCoupons = async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/coupon/list/BLACKBATON_2526`);
            if (response.data.success) {
                setCoupons(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching coupons:', error);
            toast.error('Failed to load coupons');
        }
    };

    const handleToggleStatus = async (couponId, currentStatus) => {
        try {
            const response = await axios.post(`${apiBaseUrl}/coupon/toggle-status/BLACKBATON_2526`, {
                couponId: couponId,
                isActive: !currentStatus
            });
            if (response.data.success) {
                toast.success('Coupon status updated');
                fetchCoupons();
            } else {
                toast.error(response.data.message || 'Error updating status');
            }
        } catch (error) {
            console.error('Error toggling coupon status:', error);
            toast.error('Failed to update status');
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const payload = {
            ...formData,
            DiscValue: parseFloat(formData.DiscValue) || 0,
            MinOrderAmnt: parseFloat(formData.MinOrderAmnt) || 0,
            MaxDiscount: parseFloat(formData.MaxDiscount) || 0,
            UsageLimit: parseInt(formData.UsageLimit) || null,
            PerUserLimit: parseInt(formData.PerUserLimit) || null,
            CreatedBy: localStorage.getItem('loginId') || null
        };

        try {
            const response = await axios.post(`${apiBaseUrl}/coupon/create/BLACKBATON_2526`, payload);
            if (response.data.success) {
                toast.success('Coupon created successfully!');
                setFormData({
                    CouponCode: '',
                    Description: '',
                    DiscType: 'PERCENTAGE',
                    DiscValue: '',
                    MinOrderAmnt: '',
                    MaxDiscount: '',
                    SDate: '',
                    EDate: '',
                    UsageLimit: '',
                    PerUserLimit: '',
                    IsActive: true,
                    ApplicableTo: 'CART'
                });
                fetchCoupons();
            } else {
                toast.error(response.data.message || 'Error creating coupon');
            }
        } catch (error) {
            console.error('Error creating coupon:', error);
            toast.error('Failed to create coupon');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <AdminHeader />
            <ToastContainer />
            <div className="flex-grow p-4 md:p-8 flex flex-col lg:flex-row gap-8">
                {/* Form Section */}
                <div className="w-full lg:w-1/3 bg-white p-6 rounded-lg shadow-sm border border-gray-200 h-max">
                    <h2 className="text-xl font-bold font-montserrat mb-6">Create New Coupon</h2>
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div>
                            <label className="block text-sm font-semibold mb-1">Coupon Code *</label>
                            <input type="text" name="CouponCode" value={formData.CouponCode} onChange={handleChange} required className="w-full border border-gray-300 p-2 rounded focus:outline-black uppercase" placeholder="e.g. BLACKBATON50" />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold mb-1">Description</label>
                            <textarea name="Description" value={formData.Description} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded focus:outline-black" rows="2" placeholder=""></textarea>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Discount Type</label>
                                <select name="DiscType" value={formData.DiscType} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded focus:outline-black">
                                    <option value="PERCENTAGE">Percentage (%)</option>
                                    <option value="FIXED">Fixed Amount (₹)</option>
                                </select>
                            </div>
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Discount Value *</label>
                                <input type="number" min="0" step="0.01" name="DiscValue" value={formData.DiscValue} onChange={handleChange} onWheel={(e) => e.target.blur()} required className="w-full border border-gray-300 p-2 rounded focus:outline-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Min Order Amount (₹)</label>
                                <input type="number" min="0" step="0.01" name="MinOrderAmnt" value={formData.MinOrderAmnt} onChange={handleChange} onWheel={(e) => e.target.blur()} className="w-full border border-gray-300 p-2 rounded focus:outline-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
                            </div>
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Max Discount (₹)</label>
                                <input type="number" min="0" step="0.01" name="MaxDiscount" value={formData.MaxDiscount} onChange={handleChange} onWheel={(e) => e.target.blur()} className="w-full border border-gray-300 p-2 rounded focus:outline-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" />
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Start Date</label>
                                <input type="datetime-local" name="SDate" value={formData.SDate} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded focus:outline-black" />
                            </div>
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">End Date</label>
                                <input type="datetime-local" name="EDate" value={formData.EDate} onChange={handleChange} className="w-full border border-gray-300 p-2 rounded focus:outline-black" />
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Total Usage Limit</label>
                                <input type="number" min="1" name="UsageLimit" value={formData.UsageLimit} onChange={handleChange} onWheel={(e) => e.target.blur()} className="w-full border border-gray-300 p-2 rounded focus:outline-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" placeholder="e.g. 100" />
                            </div>
                            <div className="w-1/2">
                                <label className="block text-sm font-semibold mb-1">Per User Limit</label>
                                <input type="number" min="1" name="PerUserLimit" value={formData.PerUserLimit} onChange={handleChange} onWheel={(e) => e.target.blur()} className="w-full border border-gray-300 p-2 rounded focus:outline-black [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none" placeholder="e.g. 1" />
                            </div>
                        </div>

                        <div className="flex items-center gap-2 mt-2">
                            <input type="checkbox" name="IsActive" checked={formData.IsActive} onChange={handleChange} id="isActiveCheckbox" className="w-4 h-4 cursor-pointer" />
                            <label htmlFor="isActiveCheckbox" className="text-sm font-semibold cursor-pointer">Coupon is Active</label>
                        </div>

                        <button type="submit" disabled={loading} className={`w-full h-[45px] mt-4 flex justify-center items-center rounded bg-black text-white font-montserrat font-bold transition-all ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:bg-gray-800'}`}>
                            {loading ? 'Creating...' : 'Create Coupon'}
                        </button>
                    </form>
                </div>

                {/* List Section */}
                <div className="w-full lg:w-2/3 bg-white p-6 rounded-lg shadow-sm border border-gray-200">
                    <h2 className="text-xl font-bold font-montserrat mb-6">Existing Coupons</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-gray-200 text-left text-sm text-center">
                                    <th className="p-3">Code</th>
                                    <th className="p-3">Type</th>
                                    <th className="p-3">Value</th>
                                    <th className="p-3">Min Order</th>
                                    <th className="p-3">Status</th>
                                    <th className="p-3">Usage</th>
                                </tr>
                            </thead>
                            <tbody>
                                {coupons.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className="p-4 text-center text-gray-500">No coupons found.</td>
                                    </tr>
                                ) : (
                                    coupons.map(coupon => (
                                        <tr key={coupon.CouponID} className="border-b border-gray-100 hover:bg-gray-50 text-sm">
                                            <td className="p-3 font-semibold">{coupon.CouponCode}</td>
                                            <td className="p-3">{coupon.DiscType}</td>
                                            <td className="p-3">{coupon.DiscType === 'PERCENTAGE' ? `${coupon.DiscValue}%` : `₹${coupon.DiscValue}`}</td>
                                            <td className="p-3">₹{coupon.MinOrderAmnt}</td>
                                            <td className="p-3">
                                                <button 
                                                    onClick={() => handleToggleStatus(coupon.CouponID, coupon.IsActive)}
                                                    className={`px-2 py-1 rounded text-xs font-semibold cursor-pointer transition-colors ${coupon.IsActive ? 'bg-green-100 text-green-700 hover:bg-green-200' : 'bg-red-100 text-red-700 hover:bg-red-200'}`}
                                                >
                                                    {coupon.IsActive ? 'Active' : 'Inactive'}
                                                </button>
                                            </td>
                                            <td className="p-3">{coupon.UsedCount} {coupon.UsageLimit ? `/ ${coupon.UsageLimit}` : ''}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Coupons;
